export default "__VITE_ASSET__be3a377d__"